import React from 'react'
import { hasErrors } from './'
import FormError from './FormError'

const TextAreaField = ({ field, form, showExtraInfo, ...props }) => {
  return (
    <div className="mb-6">
      <textarea
        {...field}
        {...props}
        className={`w-full py-4 px-6 text-lg rounded-lg bg-primary-lighter placeholder-black ${
          hasErrors({ field, form })
            ? 'border border-error'
            : 'border border-transparent'
        }`}
      />
      {hasErrors({ field, form }) && (
        <FormError error={form.errors[field.name]} />
      )}
      <small className="-mt-4">
        Please do not include any personal information, including your name,
        address or any other identifiable information in this box. Your details
        are captured in other fields below.
      </small>
      <br />
      {showExtraInfo && (
        <small className="font-semibold">
          Please include details of the product you bought including
          weight/size, what price the shelf label stated and what price you have
          paid, and if you scanned your More Card.
        </small>
      )}
    </div>
  )
}

export default TextAreaField
